import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AggFunc,
  ApplicationSettings,
  ApplicationSettingService,
  BaseComponent,
  BaseEditFormComponent,
  FormlyService,
  GridService,
  MenuService,
  ProductSalesOrderHistory,
  StockEnquiryService,
} from 'tms-lib';
import { StockSearch } from '../../../models';

@Component({
  selector: 'app-stock-enquiry-sales-order-history',
  templateUrl: './stock-enquiry-sales-order-history.component.html',
  styleUrl: './stock-enquiry-sales-order-history.component.scss',
})
export class StockEnquirySalesOrderHistoryComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormComponent) form: BaseEditFormComponent;

  model$: Observable<ProductSalesOrderHistory[]> = of([]);

  @Input() productId: string;

  fields: FormlyFieldConfig[];
  model: StockSearch;

  columnDefs: ColDef[] = [
    this.gridService.text('orderNo', $localize`Order Number`, { aggFunc: AggFunc.first, rowGroup: true, hide: true }),
    this.gridService.date('orderDate', $localize`Order Date`, { aggFunc: AggFunc.first }),
    this.gridService.text('customerOrderRef', $localize`Customer Order Reference`, { aggFunc: AggFunc.first }),
    this.gridService.text('customerKey', $localize`Customer`, { aggFunc: AggFunc.first }),
    this.gridService.text('customerName', $localize`Name`, { aggFunc: AggFunc.first }),
    this.gridService.text('currencyCode', $localize`Currency`, { aggFunc: AggFunc.first }),
    this.gridService.numberFormat('orderQuantity', $localize`Order Quantity`, {
      aggFunc: AggFunc.first,
      groupAggFunc: AggFunc.sum,
    }),
    this.gridService.numberFormat('orderPrice', $localize`Order Price`, { aggFunc: AggFunc.first }),
    this.gridService.numberFormat('orderValue', $localize`Order Value`, { aggFunc: AggFunc.first }),
    this.gridService.numberFormat('orderSterlingValue', $localize`Order Value (£)`, {
      aggFunc: AggFunc.first,
      groupAggFunc: AggFunc.sum,
    }),
    this.gridService.text('orderStatus', $localize`Order Status`, { aggFunc: AggFunc.first }),
    this.gridService.text('stockNo', $localize`Stock Number`),
    this.gridService.text('despatchNoteNo', $localize`Despatch Note Number`),
    this.gridService.numberFormat('despatchQuantity', $localize`Despatch Quantity`, { aggFunc: AggFunc.sum }),
    this.gridService.date('despatchDate', $localize`Despatch Date`),
    this.gridService.text('invoiceNo', $localize`Invoice Number`),
    this.gridService.date('invoiceDate', $localize`Invoice Date`),
    this.gridService.numberFormat('invoicePrice', $localize`Invoice Price`),
    this.gridService.text('deliveryAddress', $localize`Delivery Address`, { aggFunc: AggFunc.first }),
  ];

  constructor(
    public stockEnquiryService: StockEnquiryService,
    private applicationSettingService: ApplicationSettingService,
    private formlyService: FormlyService,
    private menuService: MenuService,
    private gridService: GridService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.model = { search: '' };
    if (!this.productId) {
      this.productId = this.route.snapshot.paramMap.get('id');
    }
    this.getFields();
    this.applicationSettingService
      .getBoolean(ApplicationSettings.autoLoadEnquiries)
      .pipe(takeUntil(this.destroy$))
      .subscribe((autoLoadEnquiries: boolean) => {
        if (autoLoadEnquiries) {
          this.getModel();
        }
      });
  }

  private getFields() {
    const fields = [];
    if (!this.menuService.isReadOnly) {
      fields.push(
        this.formlyService.search('search', undefined, undefined, undefined, { search: () => this.getModel() }),
      );
    }

    this.fields = fields;
  }

  getModel() {
    this.model$ = this.stockEnquiryService.getStockEnquirySalesOrderHistory(this.productId, this.model.search);
  }
}
